import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Card_3.css";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";

import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useNavigate } from "react-router-dom";
import Heart_icon from "../heart_icon/Heart_icon";
import { encodeId } from "../../../utils/common";
import Select_Product_Cart_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Cart_Modal";

const Product_Info_Card_3 = ({ product, showQty }) => {
  const [favouriteProduct, setFavouriteProduct] = useState();

  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState({});
  const [variant, setVariant] = useState({});

  console.log(product, "product product uuuuuuuuuuu");

  return (
    <section className="Product_Info_Grid_View_Section Product_Info_Card_3">
      <div className="Product_Info_Grid_View">
        <div
          className="upper_image_section"
          onClick={() =>
            navigate(`/product-description/${encodeId(product?.id)}`)
          }
        >
          <div className="card_img_holder">
            <img
              className=""
              src={process.env.REACT_APP_IMG_URL + product?.image}
              alt={product?.name}
            />
          </div>

          {/* <div className="text_div">
            <div className="discont_div">
              <p className="discount_text">{product?.discount}% Off</p>
            </div>
          </div> */}

          {product?.company && (
            <div class="company_div">
              <p class="company_text">{product?.company}</p>
            </div>
          )}
        </div>

        <div className="lower_text_section">
          <p
            className="product_name"
            onClick={() => {
              navigate(`/product-description/${encodeId(product?.id)}`);
            }}
          >
            {product?.name}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">
                ₹{product?.Product_Variants[0]?.price}
              </p>
              <p className="mrp">₹{product?.Product_Variants[0]?.mrp}</p>
              {/* <div className='discount_div'>
                                <p className='discount'>{product?.discount}</p>
                            </div> */}
            </div>

            {/* {showQty && (
              <div className="kilo_main_div">
                <div
                  className="kilo_div"
                  type="button"
                  onClick={() => Setaddcartmodal(true)}
                >
                  <div>
                    <p className="kilo_text">{product?.Unit?.name}</p>
                  </div>
                  <div>
                    <p className="icon_p">
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="down_icon"
                      />
                    </p>
                  </div>
                </div>
              </div>
            )} */}

            <div className="text-center btn_holder">
              {!product?.outofStock ? (
                <>
                  {!showIncrement ? (
                    <div className="">
                      <Green_Btn
                        btn_name="Add"
                        // leftIcon={faBasketShopping}
                        onClick={() => {
                          setShowIncrement(true);
                          Setaddcartmodal(true);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="">
                      <Green_Btn
                        btn_name="Add"
                        // leftIcon={faBasketShopping}
                        onClick={() => {
                          setShowIncrement(true);
                          Setaddcartmodal(true);
                        }}
                      />
                      {/* <IncrementDecrementBtn /> */}
                    </div>
                  )}
                </>
              ) : (
                <div className="">
                  <Red_Outline_Btn btn_name="Out of Stock" />
                </div>
              )}
            </div>
          </div>

          {/* <div className="text-center btn_holder">
            {!product?.outofStock ? (
              <>
                {!showIncrement ? (
                  <div className="">
                    <Green_Btn
                      btn_name="Add to Cart"
                      leftIcon={faBasketShopping}
                      onClick={() => {
                        setShowIncrement(true);
                        Setaddcartmodal(true);
                      }}
                    />
                  </div>
                ) : (
                  <div className="">
                    <IncrementDecrementBtn />
                  </div>
                )}
              </>
            ) : (
              <div className="">
                <Red_Outline_Btn btn_name="Out of Stock" />
              </div>
            )}
          </div> */}

          {/* <div
            className="favourite_div"
            onClick={() => setFavouriteProduct(product?.name)}
          >
            <FontAwesomeIcon
              icon={faHeart}
              className={`heart_icon ${
                product?.id == favouriteProduct ? "active" : ""
              }`}
            />
          </div> */}
          <Heart_icon product={product} />
        </div>
      </div>
      <Select_Product_Cart_Modal
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        product={product}
        show={addcartmodal}
        onHide={() => Setaddcartmodal(false)}
      />

    </section>
  );
};

export default Product_Info_Card_3;
